import http from '@/api/http'

import { PostRegisterFCMTokenPayload, PostRegisterFCMTokenResponse } from './types'

export const postRegisterFCMToken = async (
  payload: PostRegisterFCMTokenPayload
): Promise<PostRegisterFCMTokenResponse> => {
  const { device_type, token } = payload

  const response = await http.post<PostRegisterFCMTokenResponse, PostRegisterFCMTokenPayload>(
    '/notifications/fcm-tokens/',
    { token, device_type }
  )
  return response.data
}
